"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEXStatsSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
exports.DEXStatsSchema = zod_1.z.object({
    tvl: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    volume: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    tx: zod_1.z.number().int(),
    bribes: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    fees: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    income: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
});
